import request from '../untils/request';

export const statisticsAgentDataApi = params => {
  return request({
    url: '/statistics/data-agent/index',
    params,
  });
};

export const statisticsTopGoodsTitleApi = params => {
  return request({
    url: '/statistics/data-gb/total',
    params,
  });
};

export const statisticsTopGoodsApi = params => {
  return request({
    url: '/statistics/data-gb/index',
    authCode: 'DATA_TOP',
    params,
  });
};

export const statisticsIntegralApi = params => {
  return request({
    url: '/statistics/data-integral/index',
    authCode: 'DATA_INTEGRAL',
    params,
  });
};

export const statisticsSeckillApi = params => {
  return request({
    url: '/statistics/data-sec-kill/index',
    params,
  });
};

export const statisticsSeckillRemindApi = params => {
  return request({
    url: '/statistics/data-sec-kill/apply-num',
    params,
  });
};

export const statisticsEditStorageApi = params => {
  return request({
    url: '/statistics/data-sec-kill/edit-storage',
    params,
  });
};

export const statisticsDataTimeOutApi = params => {
  return request({
    url: '/statistics/data-timeout/index',
    authCode: 'DATA_TIMEOUT',
    params,
  });
};

export const statisticsAddRemarkApi = params => {
  return request({
    url: '/statistics/data-timeout/add-remark',
    params,
  });
};

export const statisticsGetRemarksApi = params => {
  return request({
    url: '/statistics/data-timeout/get-remarks',
    params,
  });
};

export const statisticsFinanceOrdersApi = params => {
  return request({
    url: '/statistics/finance/order',
    authCode: 'FINANCE_INDEX',
    params,
  });
};

export const statisticsFinanceAgentsApi = params => {
  return request({
    url: '/statistics/finance/index',
    authCode: 'FINANCE_INDEX',
    params,
  });
};

export const statisticsTimeOutTitleApi = params => {
  return request({
    url: '/statistics/data-timeout/total',
    params,
  });
};

export const statisticsYunJiApi = params => {
  return request({
    url: '/statistics/yun-ji/index',
    authCode: 'YUNJI_INDEX',
    params,
  });
};

export const statisticsRefundApi = params => {
  return request({
    url: '/statistics/data-refund/index',
    authCode: 'DATA_REFUND',
    params,
  });
};

export const statisticsRefundTitleApi = params => {
  return request({
    url: '/statistics/data-refund/total',
    params,
  });
};

export const statisticsSeckillSkuListApi = params => {
  return request({
    url: '/statistics/data-sec-kill/sku-list',
    params,
    authCode: 'DATA_SECKILL',
  });
};

export const statisticsSeckillDropListApi = params => {
  return request({
    url: '/statistics/data-sec-kill/dropdown-options',
    params,
  });
};

export const statisticsSeckillGraphicApi = params => {
  return request({
    url: '/statistics/data-sec-kill/charts',
    params,
  });
};

export const statisticsDailyNewApi = params => {
  return request({
    url: '/statistics/data-agent/daily-new',
    params,
  });
};

export const statisticsFinanceLianApi = params => {
  return request({
    url: '/statistics/finance/lian-statistics',
    params,
  });
};
